import React from "react";
import { DateField, DateTimeInput } from "react-admin";

export const CustomDatetimeField = (props) => (
  <DateField
    showTime={true}
    options={{
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }}
    {...props}
  />
);

export const CustomDateField = (props) => (
  <DateField
    options={{
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    }}
    {...props}
  />
);

const parseDateTime = (value: string) =>
  value ? new Date(value).toISOString() : value === "" ? null : value;

export const CustomDateTimeInput = (props) => (
  <DateTimeInput parse={parseDateTime} {...props} />
);
